/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StructuredAnalysisResponseData } from './StructuredAnalysisResponseData';
import {
    StructuredAnalysisResponseDataFromJSON,
    StructuredAnalysisResponseDataFromJSONTyped,
    StructuredAnalysisResponseDataToJSON,
    StructuredAnalysisResponseDataToJSONTyped,
} from './StructuredAnalysisResponseData';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponse
 */
export interface StructuredAnalysisResponse {
    /**
     * 
     */
    status?: StructuredAnalysisResponseStatusEnum;
    /**
     * 
     */
    data?: StructuredAnalysisResponseData;
}


/**
 * @export
 */
export const StructuredAnalysisResponseStatusEnum = {
    Success: 'SUCCESS',
    MemberNotFound: 'MEMBER_NOT_FOUND',
    FacilityAddressMismatch: 'FACILITY_ADDRESS_MISMATCH',
    TemporarySystemIssue: 'TEMPORARY_SYSTEM_ISSUE',
    AiDetected: 'AI_DETECTED',
    AgentError: 'AGENT_ERROR',
    InsufficientData: 'INSUFFICIENT_DATA',
    MemberDataMismatch: 'MEMBER_DATA_MISMATCH',
    InvalidFacilityData: 'INVALID_FACILITY_DATA',
    OutsideBusinessHours: 'OUTSIDE_BUSINESS_HOURS',
    RedirectTryAgain: 'REDIRECT_TRY_AGAIN',
} as const;
export type StructuredAnalysisResponseStatusEnum = typeof StructuredAnalysisResponseStatusEnum[keyof typeof StructuredAnalysisResponseStatusEnum];


/**
 * Check if a given object implements the StructuredAnalysisResponse interface.
 */
export function instanceOfStructuredAnalysisResponse(value: object): value is StructuredAnalysisResponse {
    return true;
}

export function StructuredAnalysisResponseFromJSON(json: any): StructuredAnalysisResponse {
    return StructuredAnalysisResponseFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'data': json['data'] == null ? undefined : StructuredAnalysisResponseDataFromJSON(json['data']),
    };
}

export function StructuredAnalysisResponseToJSON(json: any): StructuredAnalysisResponse {
    return StructuredAnalysisResponseToJSONTyped(json, false);
}

export function StructuredAnalysisResponseToJSONTyped(value?: StructuredAnalysisResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'data': StructuredAnalysisResponseDataToJSON(value['data']),
    };
}

